import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { myPageService } from 'shared/src/api/myPageService';
import { type RegisterPocParams } from 'shared/src/api/myPageService/registerPoc/types';

export const useRegisterPoc = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: RegisterPocParams) => {
      return await myPageService.registerPoc(params);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKey.pocList() });
    },
    throwOnError: false,
  });
};
